import { useSelector } from 'react-redux';
import { ApiError } from 'modules/Common/types';
import { createApiErrorSelector } from '../reducers';

export default (apiAction: string): ApiError | null => {
  return useSelector(state => createApiErrorSelector(apiAction)(state));
};
